import phoneReducer from "./reducers/phoneSlice";
import userReducer from "./reducers/userSlice";
import dashboardReducer from "./reducers/dashboardSlice";
import  {apiConfig}  from "../api/endpoints/apiConfig";
import { combineReducers } from '@reduxjs/toolkit';
import {funFactApi} from "../api/funfactApi";
import idReducer from './reducers/aircallTagSlice';
import dispositionReducer from './reducers/dispositionSlice';
// Combine all slice reducers into a single rootReducer
const rootReducer = combineReducers({
    phone: phoneReducer,
    user: userReducer,
    dashboard: dashboardReducer,
    disposition:dispositionReducer,
    [apiConfig.reducerPath]: apiConfig.reducer,
    [funFactApi.reducerPath]: funFactApi.reducer,
    ids: idReducer,
});

export default rootReducer;